import type * as core from '../../../../../core'

export const PACKAGE = {
  contents: [
    'package:apps.ascendChangeImpacts',
    '-resource:solutions.mosaic.actions.changeImpacts.saveChangeImpact',
    '-resource:solutions.mosaic.pages.changeImpacts.changeImpactLog',
    '-resource:solutions.mosaic.pages.changeImpacts.dashboard',
    '-resource:solutions.mosaic.pages.changeImpacts.details',
    '-resource:solutions.mosaic.pages.changeImpacts.changeImpacts',
    '-resource:solutions.mosaic.widgets.changeImpacts.anticipatedResponseOfChange',
    '-resource:solutions.mosaic.widgets.changeImpacts.anticipatedResponseOfChangeByDepartment',
    '-resource:solutions.mosaic.widgets.changeImpacts.anticipatedResponseOfChangeByFunctionalArea',
    '-resource:solutions.mosaic.widgets.changeImpacts.areaOfConcernByFunctionalArea',
    '-resource:solutions.mosaic.widgets.changeImpacts.changeImpactDetails',
    '-resource:solutions.mosaic.widgets.changeImpacts.changeImpactLog',
    '-resource:solutions.mosaic.widgets.changeImpacts.changeImpactsByDepartment',
    '-resource:solutions.mosaic.widgets.changeImpacts.changeImpactsByEpic',
    '-resource:solutions.mosaic.widgets.changeImpacts.changeImpactsByEpicAndFunctionalArea',
    '-resource:solutions.mosaic.widgets.changeImpacts.changeImpactsByStatus',
    '-resource:solutions.mosaic.widgets.changeImpacts.changeImpactsByValidationStatus',
    '-resource:solutions.mosaic.widgets.changeImpacts.changeImpactsTable',
    '-resource:solutions.mosaic.widgets.changeImpacts.communicationsNeededByDepartment',
    '-resource:solutions.mosaic.widgets.changeImpacts.communicationsNeededByFunctionalArea',
    '-resource:solutions.mosaic.widgets.changeImpacts.createChangeImpactModal',
    '-resource:solutions.mosaic.widgets.changeImpacts.degreeAndValueOfChangeTable',
    '-resource:solutions.mosaic.widgets.changeImpacts.degreeOfChangeBarChart',
    '-resource:solutions.mosaic.widgets.changeImpacts.degreeOfChangeByDepartment',
    '-resource:solutions.mosaic.widgets.changeImpacts.degreeOfChangeByEpic',
    '-resource:solutions.mosaic.widgets.changeImpacts.degreeOfChangeByFunctionalArea',
    '-resource:solutions.mosaic.widgets.changeImpacts.editChangeImpactModal',
    '-resource:solutions.mosaic.widgets.changeImpacts.functionalAreaBarChart',
    '-resource:solutions.mosaic.widgets.changeImpacts.highRiskTable',
    '-resource:solutions.mosaic.widgets.changeImpacts.keyBenefitsByFunctionalArea',
    '-resource:solutions.mosaic.widgets.changeImpacts.outstandingImpactsByPriority',
    '-resource:solutions.mosaic.widgets.changeImpacts.overviewReportCard',
    '-resource:solutions.mosaic.widgets.changeImpacts.phaseBarChart',
    '-resource:solutions.mosaic.widgets.changeImpacts.trainingImplicationsByDepartment',
    '-resource:solutions.mosaic.widgets.changeImpacts.trainingImplicationsByFunctionalArea',
    '-resource:solutions.mosaic.widgets.changeImpacts.typeBarChart',
    '-resource:solutions.mosaic.widgets.changeImpacts.valueOfChangeBarChart',
    '-resource:solutions.mosaic.widgets.changeImpacts.valueOfChangeByEpic',
    '-resource:solutions.mosaic.widgets.changeImpacts.valueOfChangeByFunctionalArea',
    'resource:solutions.mosaic.actions.workdayChangeImpacts.saveChangeImpact',
    'resource:solutions.mosaic.pages.workdayChangeImpacts.changeImpactLog',
    'resource:solutions.mosaic.pages.workdayChangeImpacts.dashboard',
    'resource:solutions.mosaic.pages.workdayChangeImpacts.details',
    'resource:solutions.mosaic.pages.workdayChangeImpacts.changeImpacts',
    'resource:solutions.mosaic.widgets.workdayChangeImpacts.anticipatedResponseOfChange',
    'resource:solutions.mosaic.widgets.workdayChangeImpacts.anticipatedResponseOfChangeByDepartment',
    'resource:solutions.mosaic.widgets.workdayChangeImpacts.anticipatedResponseOfChangeByTeam',
    'resource:solutions.mosaic.widgets.workdayChangeImpacts.anticipatedResponseOfChangeByWorkstream',
    'resource:solutions.mosaic.widgets.workdayChangeImpacts.areaOfConcernByWorkstream',
    'resource:solutions.mosaic.widgets.workdayChangeImpacts.changeImpactDetails',
    'resource:solutions.mosaic.widgets.workdayChangeImpacts.changeImpactLog',
    'resource:solutions.mosaic.widgets.workdayChangeImpacts.changeImpactsByDepartment',
    'resource:solutions.mosaic.widgets.workdayChangeImpacts.changeImpactsByEpic',
    'resource:solutions.mosaic.widgets.workdayChangeImpacts.changeImpactsByEpicAndWorkstream',
    'resource:solutions.mosaic.widgets.workdayChangeImpacts.changeImpactsByStatus',
    'resource:solutions.mosaic.widgets.workdayChangeImpacts.changeImpactsByTeam',
    'resource:solutions.mosaic.widgets.workdayChangeImpacts.changeImpactsByValidationStatus',
    'resource:solutions.mosaic.widgets.workdayChangeImpacts.changeImpactsTable',
    'resource:solutions.mosaic.widgets.workdayChangeImpacts.communicationsNeededByDepartment',
    'resource:solutions.mosaic.widgets.workdayChangeImpacts.communicationsNeededByWorkstream',
    'resource:solutions.mosaic.widgets.workdayChangeImpacts.createChangeImpactModal',
    'resource:solutions.mosaic.widgets.workdayChangeImpacts.degreeAndValueOfChangeTable',
    'resource:solutions.mosaic.widgets.workdayChangeImpacts.degreeOfChangeBarChart',
    'resource:solutions.mosaic.widgets.workdayChangeImpacts.degreeOfChangeByDepartment',
    'resource:solutions.mosaic.widgets.workdayChangeImpacts.degreeOfChangeByEpic',
    'resource:solutions.mosaic.widgets.workdayChangeImpacts.degreeOfChangeByTeam',
    'resource:solutions.mosaic.widgets.workdayChangeImpacts.degreeOfChangeByWorkstream',
    'resource:solutions.mosaic.widgets.workdayChangeImpacts.editChangeImpactModal',
    'resource:solutions.mosaic.widgets.workdayChangeImpacts.highRiskTable',
    'resource:solutions.mosaic.widgets.workdayChangeImpacts.keyBenefitsByWorkstream',
    'resource:solutions.mosaic.widgets.workdayChangeImpacts.outstandingImpactsByPriority',
    'resource:solutions.mosaic.widgets.workdayChangeImpacts.overviewReportCard',
    'resource:solutions.mosaic.widgets.workdayChangeImpacts.phaseBarChart',
    'resource:solutions.mosaic.widgets.workdayChangeImpacts.trainingImplicationsByDepartment',
    'resource:solutions.mosaic.widgets.workdayChangeImpacts.trainingImplicationsByWorkstream',
    'resource:solutions.mosaic.widgets.workdayChangeImpacts.typeBarChart',
    'resource:solutions.mosaic.widgets.workdayChangeImpacts.valueOfChangeBarChart',
    'resource:solutions.mosaic.widgets.workdayChangeImpacts.valueOfChangeByEpic',
    'resource:solutions.mosaic.widgets.workdayChangeImpacts.valueOfChangeByWorkstream',
    'resource:solutions.mosaic.widgets.workdayChangeImpacts.workstreamBarChart',
    'resource:data.dimensions.changeImpacts.entities.changeImpact.attributes.team',
    'resource:data.dimensions.changeImpacts.entities.changeImpact.attributes.workstream',
    'resource:data.enums.changeImpactTeam',
    'resource:data.enums.changeImpactTeam.entries.fin',
    'resource:data.enums.changeImpactTeam.entries.hcm',
    'resource:data.enums.changeImpactTeam.entries.technical',
    'resource:data.enums.changeImpactTeam.entries.changeManagement',
    'resource:data.enums.changeImpactTeam.entries.other',
    'resource:data.enums.changeImpactWorkstream',
    'resource:data.enums.changeImpactWorkstream.entries.absence',
    'resource:data.enums.changeImpactWorkstream.entries.academicStaffing',
    'resource:data.enums.changeImpactWorkstream.entries.adaptive',
    'resource:data.enums.changeImpactWorkstream.entries.bankingAndSetttlement',
    'resource:data.enums.changeImpactWorkstream.entries.benefits',
    'resource:data.enums.changeImpactWorkstream.entries.businessAssets',
    'resource:data.enums.changeImpactWorkstream.entries.compensation',
    'resource:data.enums.changeImpactWorkstream.entries.coreFinancialsFdm',
    'resource:data.enums.changeImpactWorkstream.entries.crossFunctional',
    'resource:data.enums.changeImpactWorkstream.entries.customerAccounts',
    'resource:data.enums.changeImpactWorkstream.entries.data',
    'resource:data.enums.changeImpactWorkstream.entries.effortReporting',
    'resource:data.enums.changeImpactWorkstream.entries.financialAccounting',
    'resource:data.enums.changeImpactWorkstream.entries.general',
    'resource:data.enums.changeImpactWorkstream.entries.grants',
    'resource:data.enums.changeImpactWorkstream.entries.hcmCore',
    'resource:data.enums.changeImpactWorkstream.entries.integrations',
    'resource:data.enums.changeImpactWorkstream.entries.inventoryManagement',
    'resource:data.enums.changeImpactWorkstream.entries.learning',
    'resource:data.enums.changeImpactWorkstream.entries.payroll',
    'resource:data.enums.changeImpactWorkstream.entries.payrollAccounting',
    'resource:data.enums.changeImpactWorkstream.entries.procurement',
    'resource:data.enums.changeImpactWorkstream.entries.recruiting',
    'resource:data.enums.changeImpactWorkstream.entries.reporting',
    'resource:data.enums.changeImpactWorkstream.entries.supplierAccounts',
    'resource:data.enums.changeImpactWorkstream.entries.talent',
    'resource:data.enums.changeImpactWorkstream.entries.timeTracking',
  ],
  description:
    'A package containing entities and resources specific to the Workday Change Impacts application.',
  name: 'Workday Change Impacts',
} as const satisfies core.quiver.Package
